const login = {
  title: 'Welcome Back!',
  subtitle: 'Enter your email to continue.',
  subtitleCode: 'Enter the code sent to your email.',

  email: 'Email',
  emailDescription:
    'You will receive an email with a one time password to login.',
  code: 'Verification Code',
  codeDescription: 'Check your email for the 8-digit code.',

  continue: 'Continue',
  verify: 'Verify Code',
  cancel: 'Cancel',
  resend: 'Resend Code',

  otpTitle: 'One-Time Password',
  otpSubtitle: 'Enter the code sent to your email.',
  otpContinue: 'Continue',
  sending: 'Sending...',
  verifying: 'Verifying...',
  back: 'Back',
  password: 'Password',

  socialLogin: {
    apple: 'Continue with Apple',
    google: 'Continue with Google',
  },

  verifyingSignIn: 'Verifying sign in...',
  signInFailed: 'Sign in failed. Please try again.',

  downloadBanner: {
    title: 'Get the app',
    subtitle: 'Use Voicefill Medical on the go with the native app.',
    cta: 'Download',
    dismissA11y: 'Dismiss banner',
  },
};

export default login;
